module.exports = __webpack_public_path__ + "assets/img/footer4.d0289dc0.png";